import classnames from "classnames";
import React, { useState } from "react";

import { DefaultFacetDisplayValue } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/DefaultFacet/defaultFacet.container";

type DefaultFacetValueComponentProps = {
    value: DefaultFacetDisplayValue;
    showCount: boolean;
};

const DefaultFacetValueComponent = ({
    value,
    showCount,
}: DefaultFacetValueComponentProps) => {
    const [isCheckedOptimistic, setIsCheckedOptimistic] = useState<boolean>(
        value.refined,
    );

    const handleOnChange = () => {
        setIsCheckedOptimistic(isChecked => !isChecked);
        value.onRefine();
    };

    return (
        <li>
            <label
                className={"cursor-pointer d-flex align-items-center mb-0 py-1"}
                title={value.label}
            >
                <div className={"truncate__wrapper d-flex align-items-center"}>
                    <input
                        type="checkbox"
                        className="mr-2 cursor-pointer"
                        checked={isCheckedOptimistic}
                        onChange={handleOnChange}
                    />
                    <div
                        className={classnames(
                            "text-capitalize-first-char truncate",
                            isCheckedOptimistic && "font-weight-bold",
                        )}
                    >
                        {value.label}
                    </div>
                </div>

                {showCount && <small className="pl-2">({value.count})</small>}
            </label>
        </li>
    );
};

export { DefaultFacetValueComponent };
